import {getPreviousDate, getMonth, getQuarter, getYear, getNextDate, getCurrentDate} from '@ui-seeker/utils'

import {DATE_PERIODS} from "@constants";
import { currentPeriod } from "@signals"


const currentDay = new Date().getDay()
const currentMonth = getMonth()
const currentYear = getYear()
const currentQuarter = getQuarter()

const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1
const lastQuarterMonth = lastQuarter * 3
const lastQuarterYear = currentQuarter === 1 ? currentYear - 1 : currentYear

const nextQuarter = currentQuarter === 4 ? 1 : currentQuarter + 1;
const nextQuarterMonth = (nextQuarter - 1) * 3;
const nextQuarterYear = currentQuarter === 4 ? currentYear + 1 : currentYear;

export const dipRangeDates = [{
	label: 'Yesterday',
	value: [getPreviousDate({ days: 1 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.YESTERDAY
}, {
	label: 'Last 7 Days',
	value: [getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_7_DAYS
}, {
	label: 'Last 30 Days',
	value: [getPreviousDate({ days: 30 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_30_DAYS
}, {
	label: 'Last 60 Days',
	value: [getPreviousDate({ days: 60 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_60_DAYS
}, {
	label: 'Last 90 Days',
	value: [getPreviousDate({ days: 90 }), getPreviousDate({ days: 1 })],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_90_DAYS
}, {
	label: 'Last Month',
	value: [
		getPreviousDate({ months: 1 }, new Date(currentYear, currentMonth - 1, 1)),
		getPreviousDate({ days: 1 },  new Date(currentYear, currentMonth - 1, 1))
	],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_MONTH
}, {
	label: 'Last Quarter',
	value: [
		new Date(lastQuarterYear, lastQuarterMonth - 3, 1),
		new Date(lastQuarterYear, lastQuarterMonth, 0)
	],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_QUARTER
}, {
	label: 'Year to Date',
	value: [
		new Date(currentYear, 0, 1),
		currentDay === 1 && currentMonth === 0 ? new Date(currentYear, 0, 1) : getPreviousDate({ days: 1 })
	],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.YEAR_TO_DATE
}, {
	label: 'Last Year',
	value: [
		getPreviousDate({ years: 1 }, new Date(currentYear, 0, 1)),
		getPreviousDate({ years: 1 }, new Date(currentYear, 12, 0))
	],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.LAST_YEAR
}]

export const dipRangeDatesWithToday = [{
	label: 'Today',
	value: [getCurrentDate(), getCurrentDate()],
	placement: 'left',
	onFocus: () => currentPeriod.value = DATE_PERIODS.TODAY
}, ...dipRangeDates
]

export const dipFutureRangeDates = [
	{
		label: 'Tomorrow',
		value: [getNextDate({ days: 1 }), getNextDate({ days: 1 })],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.TOMORROW
	},
	{
		label: 'Next 7 Days',
		value: [getNextDate({ days: 1 }), getNextDate({ days: 7 })],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.NEXT_7_DAYS
	},
	{
		label: 'Next 30 Days',
		value: [getNextDate({ days: 1 }), getNextDate({ days: 30 })],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.NEXT_30_DAYS
	},
	{
		label: 'Next 60 Days',
		value: [getNextDate({ days: 1 }), getNextDate({ days: 60 })],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.NEXT_60_DAYS
	},
	{
		label: 'Next 90 Days',
		value: [getNextDate({ days: 1 }), getNextDate({ days: 90 })],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.NEXT_90_DAYS
	},
	{
		label: 'Next Month',
		value: [
			new Date(currentYear, currentMonth + 1, 1),
			new Date(currentYear, currentMonth + 2, 0)
		],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.NEXT_MONTH
	},
	{
		label: 'Next Quarter',
		value: [
			new Date(nextQuarterYear, nextQuarterMonth, 1),
			new Date(nextQuarterYear, nextQuarterMonth + 3, 0)
		],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.NEXT_QUARTER
	},
	{
		label: 'Year Ahead',
		value: [
			new Date(currentYear + 1, 0, 1),
			new Date(currentYear + 1, 11, 31)
		],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.YEAR_AHEAD
	},
	{
		label: 'Current Year',
		value: [
			new Date(currentYear, 0, 1),
			new Date(currentYear, 11, 31)
		],
		placement: 'left',
		onFocus: () => currentPeriod.value = DATE_PERIODS.CURRENT_YEAR
	}
]